import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Urmăritori',
  fields: {
    name: 'Nume',
    subscribed: 'Abonat',
    followed: 'Urmăritor',
    phone: 'Telefon',
    recent_order: 'Comandă recentă',
    total_orders: 'Total comenzi',
    birthday: 'Data nașterii',
    google_review: 'Recenzie Google',
    marketing_subscription_source: 'Abonat din',
    loyalty_points: 'Fidelitate',
  },
  empty_list: 'Niciun client încă',
  yes: 'Da',
  no: 'Nu',
  buttons: {
    import: 'Import',
    export: 'Export',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
  labels: {
    followed_since_date: 'Din {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
